import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const initSlider = () => {
    let swiperInstances = [];
    const pauseAllVideos = (container) => {
        if (!container) return;
        const videos = container.querySelectorAll('video');
        videos.forEach(video => {
            try {
                if (!video.paused) {
                    video.pause();
                }
            } catch (e) {
                // ignore
            }
        });
    };
    const initializeSliders = () => {
        // Destroy existing swiper instances
        swiperInstances.forEach(swiper => {
            if (swiper && swiper.destroy) {
                swiper.destroy(true, true);
            }
        });
        swiperInstances = [];

        // Initialize text-image sliders
        const textImageSwipers = document.querySelectorAll('.text-image-slider-swiper');
        textImageSwipers.forEach(swiperEl => {
            // Find navigation and pagination elements within this specific slider container
            const nextButton = swiperEl.querySelector('.swiper-button-next');
            const prevButton = swiperEl.querySelector('.swiper-button-prev');
            const pagination = swiperEl.querySelector('.swiper-pagination');

            const swiper = new Swiper(swiperEl, {
                modules: [Navigation, Pagination, Autoplay],
                spaceBetween: 30,
                slidesPerView: 1,
                loop: true,
                speed: 1000,
                pagination: {
                    el: pagination,
                    clickable: true,
                },
                navigation: {
                    nextEl: nextButton,
                    prevEl: prevButton,
                },
                on: {
                    // Pause any playing videos when the slide is about to change
                    slideChangeTransitionStart: () => pauseAllVideos(swiperEl),
                    // Also pause on drag/touch start to be safe
                    touchStart: () => pauseAllVideos(swiperEl),
                    // And when autoplay advances
                    autoplay: () => pauseAllVideos(swiperEl),
                }
            });
            swiperInstances.push(swiper);
        });

        // Initialize logo sliders
        const logoSwipers = document.querySelectorAll('.logo-slider-swiper');
        logoSwipers.forEach(swiperEl => {
            const swiper = new Swiper(swiperEl, {
                modules: [Autoplay, Pagination, Navigation],
                loop: true,
                spaceBetween: 16,
                slidesPerView: 3,
                speed: 6000,
                autoplay: {
                    delay: 0,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: false,
                },
                breakpoints: {
                    576: {
                        slidesPerView: 3,
                    },
                    768: {
                        slidesPerView: 4,
                    },
                    1024: {
                        slidesPerView: 5,
                    },
                    1280: {
                        slidesPerView: 5,
                    }
                },
            });
            swiperInstances.push(swiper);
        });
    };

    // Initialize sliders on load
    initializeSliders();

    // Reinitialize sliders on window resize
    window.addEventListener('resize', () => {
        initializeSliders();
    });
};

export default initSlider;